import adminApi from './adminApi';

export const getStoreVisits = async (
  memberId,
  viewAll = false,
  storeId = ''
) => {
  let url = `store-visits/transactions?memberId=${memberId}&viewAll=${viewAll}`;
  if (storeId) url += `&storeId=${encodeURIComponent(storeId)}`;
  const response = await adminApi.get(url);
  return response?.data;
};

export const getVisitedStores = async (memberId) => {
  const response = await adminApi.get(
    `store-visits/visited-stores?memberId=${memberId}`
  );
  return response?.data;
};
